var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["AbortController"]: () => (__WEBPACK_EXTERNAL_MODULE_node_abort_controller_979daf39__.AbortController) });